import { render, staticRenderFns } from "./ReferenceFiles.vue?vue&type=template&id=5d607b63&scoped=true&"
import script from "./ReferenceFiles.vue?vue&type=script&lang=js&"
export * from "./ReferenceFiles.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceFiles.vue?vue&type=style&index=0&id=5d607b63&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d607b63",
  null
  
)

export default component.exports